export default {
  SELECT_ORDER: 'ORDER/SELECT_ORDER',
  UPDATE_REQUEST_SERVICE_TIME: 'ORDER/UPDATE_REQUEST_SERVICE_TIME',
}
